import { useContext } from "react";
import { SearchFormContext } from "../context";

const useSearchFormContext = () => {
  const context = useContext(SearchFormContext);
  if (!context) {
    console.warn(
      "useSearchFormContext must be used within a SearchFormProvider"
    );
    return {
      search: "",
      setSearch: () => undefined
    };
  }
  return context;
};

export default useSearchFormContext;
